import { z } from "zod";
import { PublicIdSchema } from "./common";

export const BusinessAlertKind = z.enum([
  "distance_deviation_alert",
  "unconfirmed_instruction",
  "unsubmitted_report",
  "alcohol_check_failed",
  "vehicle_inspection_ng",
  "license_expiration_alert",
  "daily_report_rejected",
  "delay_reported",
  // #628: 到着オドメーターが未入力のまま退勤した稼働日 (支払距離が算出できない)
  "unrecorded_arrival_odometer",
]);

export const BusinessAlertStatus = z.enum(["active", "resolved"]);

export const BusinessAlertTarget = z
  .discriminatedUnion("kind", [
    // #627: 距離突合 (F27) の廃止に伴い、走行距離乖離は「計画距離 vs 運転日報 ODO」の
    // 導出値だけで判定する。導線も距離突合ではなく運転日報へ向ける。
    z.object({
      kind: z.literal("distance"),
      route_public_id: PublicIdSchema,
      date: z.iso.date(),
    }),
    z.object({
      kind: z.literal("route"),
      route_public_id: PublicIdSchema,
      date: z.iso.date(),
    }),
    z.object({
      kind: z.literal("report"),
      report_public_id: PublicIdSchema,
    }),
    z.object({
      kind: z.literal("order"),
      order_public_id: PublicIdSchema,
      order_number: z.string().nullable(),
    }),
  ])
  .nullable();

export const BusinessAlert = z.object({
  id: PublicIdSchema,
  kind: BusinessAlertKind,
  title: z.string(),
  body: z.string(),
  status: BusinessAlertStatus,
  occurred_at: z.iso.datetime({ offset: true }),
  resolved_at: z.iso.datetime({ offset: true }).nullable(),
  target: BusinessAlertTarget,
});

export const ListBusinessAlertsInput = z.object({
  status: BusinessAlertStatus.optional(),
  limit: z.coerce.number().int().min(1).max(100).default(100),
  cursor: z.string().min(1).optional(),
});

export const BusinessAlertListResponse = z.object({
  data: z.array(BusinessAlert),
  pagination: z.object({
    total: z.number().int().min(0),
    limit: z.number().int().min(1).max(100),
    has_more: z.boolean(),
    next_cursor: z.string().nullable(),
  }),
});

export type BusinessAlertKindDto = z.infer<typeof BusinessAlertKind>;
export type BusinessAlertStatusDto = z.infer<typeof BusinessAlertStatus>;
export type BusinessAlertTargetDto = z.infer<typeof BusinessAlertTarget>;
export type BusinessAlertDto = z.infer<typeof BusinessAlert>;
export type ListBusinessAlertsInputDto = z.infer<typeof ListBusinessAlertsInput>;
export type BusinessAlertListResponseDto = z.infer<typeof BusinessAlertListResponse>;
